/// <reference path="../notes/NoteDetailHeaderView.ts" />


class InventoryNoteDetailHeader extends NoteDetailHeaderView
{
    private documentIDLabel:MUILabel = null;
    private destinationNameLabel:MUILabel = null;

    private referenceTextField:MUITextField = null;
    private referenceLabel:MUILabel = null;

    private documentDateLabel:MUILabel = null;
    private documentDateTextField:MUITextField = null;
    private documentDateButton:MUIButton = null;

    private validationDateLabel:MUILabel = null;
    private validationDateTextField:MUITextField = null;
    private validationDateButton:MUIButton = null;  

    private sortButton:MUIButton = null;
    columnFilterTextField:ColumnFilterTextField = null;

    awakeFromHTML(){
        super.awakeFromHTML();

        this.documentIDLabel = MUIOutlet(this, "document-id-lbl", "MUILabel");
        this.destinationNameLabel = MUIOutlet(this, "destination-lbl", "MUILabel");

        this.documentDateLabel = MUIOutlet(this, "document-date-lbl", "MUILabel");
        this.documentDateTextField = MUIOutlet(this, "document-date-tf", "MUITextField");
        this.setupDocumentDateTextField(this.documentDateTextField);
        this.documentDateButton = MUIOutlet(this, "document-date-btn", 'MUIButton');
        this.setupCalendarButton(this.documentDateButton, NoteDetailHeaderViewDateType.DocumentDate);

        this.validationDateLabel = MUIOutlet(this, "validation-date-lbl", "MUILabel");
        this.validationDateTextField = MUIOutlet(this, "validation-date-tf", "MUITextField");
        this.setupValidationDateTextField(this.validationDateTextField);
        this.validationDateButton = MUIOutlet(this, "validation-date-btn", "MUIButton");
        this.setupCalendarButton(this.validationDateButton, NoteDetailHeaderViewDateType.ValidationDate);

        this.referenceTextField = MUIOutlet(this, "reference-tf", "MUITextField");
        if (this.referenceTextField != null) this.referenceTextField.setOnChangeText(this, function (control, value){
            this.stockNote.externalReference = value;
        });
        this.referenceLabel = MUIOutlet(this, "reference-lbl", "MUILabel"); 
        
        this.columnFilterTextField = MUIOutlet(this, "search-column", "ColumnFilterTextField");
        this.sortButton = MUIOutlet(this, "sort-btn", "MUIButton");
        if (this.sortButton != null)this.sortButton.setAction(this, this.sortButtonDidClick);
    }
    
    set note(value:StockNote){
        this.stockNote = value;

        this.documentIDLabel.text = value.documentID;
        this.destinationNameLabel.text = value.destinationName;

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        let documentDateString = ad.dateTimeFormatter.stringFromDate(value.documentDate);
        if (this.documentDateLabel != null) this.documentDateLabel.text = documentDateString;
        if (this.documentDateTextField != null) this.documentDateTextField.text = documentDateString;

        let stockDateString = ad.dateTimeFormatter.stringFromDate(value.stockDate);
        if (this.validationDateLabel != null) this.validationDateLabel.text = stockDateString;
        if (this.validationDateTextField != null) this.validationDateTextField.text = stockDateString;

        if (this.referenceTextField != null) this.referenceTextField.text = value.externalReference;
        if (this.referenceLabel != null) this.referenceLabel.text = value.externalReference;
    }
    
    private dtf = MUIWebApplication.sharedInstance().delegate.dateTimeFormatter as MIODateFormatter;
    protected dateDidChange(type:NoteDetailHeaderViewDateType, date:Date){
        switch(type){
            case NoteDetailHeaderViewDateType.DocumentDate:
            this.documentDateTextField.text = this.dtf.stringFromDate(date);
            break;

            case NoteDetailHeaderViewDateType.ValidationDate:
            this.validationDateTextField.text = this.dtf.stringFromDate(date);
            break;
        }
    }

    private action = null;
    private target = null;
    private column:MUIReportTableViewColumn = null;
    setAction(target, action, column:MUIReportTableViewColumn){
        this.target = target;
        this.action = action;
        this.column = column;
    }

    private sortButtonDidClick(){
        if (this.action == null || this.target == null) return;

        MUICoreLayerRemoveStyle(this.sortButton.layer, "order-sort");
        MUICoreLayerRemoveStyle(this.sortButton.layer, "order-sort-asc");
        MUICoreLayerRemoveStyle(this.sortButton.layer, "order-sort-desc");

        if (this.column.ascending == true) {
            MUICoreLayerAddStyle(this.sortButton.layer, "order-sort-asc");
        }
        else if (this.column.ascending == false) {
            MUICoreLayerAddStyle(this.sortButton.layer, "order-sort-desc");
        }

        this.action.call(this.target, this.column);
    }
}